import '@theme/dialog';

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-dialog-open]');
  if (!(trigger instanceof HTMLElement)) return;

  const dialogId = trigger.dataset.dialogOpen;
  if (!dialogId) return;

  const dialog = document.getElementById(dialogId)?.closest('modal-dialog');
  if (!dialog || typeof dialog.open !== 'function') return;

  event.preventDefault();
  dialog.open(trigger);
});

document.addEventListener('shopify:section:load', () => {
  document.dispatchEvent(new CustomEvent('theme:section:load'));
});
